import {
  startOfISOWeek,
  startOfMonth,
  endOfISOWeek,
  endOfMonth,
  differenceInCalendarDays,
  add,
  eachDayOfInterval,
  isSameDay,
  format,
  endOfDay,
} from 'date-fns';
import { it } from 'date-fns/locale';

export const USER_DOCS_PREFIX = 'checkpoint_users_data';

export const createDays = (month: Date) => {
  const primo = startOfISOWeek(startOfMonth(month));
  const ultimo = endOfISOWeek(endOfMonth(month));
  const giorni = Math.abs(differenceInCalendarDays(primo, ultimo));
  let days = [primo];
  for (let i = 1; i <= giorni; i++) {
    days.push(add(primo, { days: i }));
  }
  return days;
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const a = document.createElement('a');
  const objectUrl = URL.createObjectURL(blob);
  a.href = objectUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(objectUrl);
};

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const firstToUpperCase = (str: string | undefined) =>
  str
    ? str
      .split('')
      .map((x, index) => (index === 0 ? x.toUpperCase() : x))
      .join('')
    : undefined;

export const manipulateToUTCDate = (sourceDate: Date): Date => {
  return new Date(Date.UTC(sourceDate.getFullYear(), sourceDate.getMonth(), sourceDate.getDate(), 0, 0, 0, 0));
};
export const manipulateToUTCDateTime = (sourceDate: Date): Date => {
  return new Date(
    Date.UTC(
      sourceDate.getFullYear(),
      sourceDate.getMonth(),
      sourceDate.getDate(),
      sourceDate.getHours(),
      sourceDate.getMinutes(),
      sourceDate.getSeconds(),
      sourceDate.getMilliseconds(),
    ),
  );
};

export const manipulateToUTCISOString = (
  sourceDate: Date | string,
  withTime: boolean = true,
  endOfDate: boolean = false,
): string => {
  let resultDate: Date;

  if (typeof sourceDate === 'string') {
    resultDate = new Date(sourceDate);
  } else {
    resultDate = sourceDate;
  }

  if (endOfDate) {
    resultDate = endOfDay(resultDate);
  }
  if (withTime) {
    return manipulateToUTCDateTime(resultDate).toISOString();
  }
  return manipulateToUTCDate(resultDate).toISOString();
};

